<script setup lang="ts">
import { type HTMLAttributes } from 'vue'
import { Button, type ButtonVariants } from '@/components/ui/button'
import { SpinnerIcon } from '@/components/icons'
import { computed } from 'vue'

interface Props {
  loading?: boolean
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  disabled?: string | true | undefined
  class?: HTMLAttributes['class']
  type?: 'button' | 'submit' | 'reset'
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  disabled: undefined,
  type: 'button'
})

// Convert string boolean values to actual booleans
const isDisabled = computed(() => {
  return props.disabled || props.loading
})

const isLoading = computed(() => {
  return props.loading
})
</script>

<template>
  <Button
    :variant="props.variant"
    :size="props.size"
    :disabled="isDisabled"
    :class="[props.class, 'relative']"
    :type="props.type"
  >
    <div v-if="isLoading" class="absolute inset-0 flex items-center justify-center">
      <SpinnerIcon class="h-5 w-5" />
    </div>
    <span :class="{ 'opacity-0': isLoading }">
      <slot />
    </span>
  </Button>
</template>
